import { createContext, Dispatch, SetStateAction } from 'react';

export interface ModalContextType {
    isModalOpen: boolean;
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    modal: any;
    setModal: Dispatch<SetStateAction<any>>;
}

export const ModalContext = createContext<ModalContextType>({
    isModalOpen: false,
    setIsModalOpen: () => undefined,
    modal: null,
    setModal: () => undefined,
});
